"use strict";
/**
 * a11yCore module - used as a namespace.
 * @module a11yCore
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colorJs = require("./color.js");

exports.Color = _colorJs.Color;
exports.calculateContrastRatio = _colorJs.calculateContrastRatio;
exports.flattenColors = _colorJs.flattenColors;
exports.parseColor = _colorJs.parseColor;
exports.suggestColors = _colorJs.suggestColors;